import React from "react";
import { Drawer, Box, IconButton } from "@mui/material";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import PaidIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import down from "../../../../assets/down.svg";
import view from "../../../../assets/Wallet/view.png";
import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown";
import StatusDropdown from "../../../../components/StatusDropdown";
import receipt from "../../../../assets/Wallet/receipt.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";

const DetailsDrawer = ({ open, onClose, data }) => {
  const { t } = useTranslation();
    const [editOpen, setEditOpen] = React.useState(false);

  console.log(data);
    const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const localDate = convertUTCToLocalDateTime(dateString, {
    locale: "en-GB",
    formatOptions: {
      day: "2-digit",
      month: "short",
      year: "numeric",
    },
  });
  return localDate === "—" ? "-" : localDate;
};
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 550,
          maxWidth: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#E7EBEE",
          p: 1.3,
          borderBottom: "1px solid #E0E0E0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
{t("salaryManagement.request")}          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}>
        {/* Status & Date */}
        <Box
          sx={{
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              mt: 1,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.status")}
            </CustomText>

              <Box sx={{ pointerEvents: "none" }}>
                    
                    <StatusDropdown currentStatus={data?.status} />
                    </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.date")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
                              {formatDateTime(data?.paid_at)}
            </CustomText>{" "}
          </Box>

              <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              mt: 1,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
           {t("salaryManagement.comments")}
            </CustomText>

            <Box
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "right",
              }}
            >
{data?.note || "-"}            </Box>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 600,
              color: "#000000",
              textAlign: "left",
            }}
          >
{t("salaryManagement.requestDetails")}
        </CustomText>
          <img src={down} width={40} height={30} />
        </Box>

        <Box
          sx={{
            p: 2,
            overflowY: "auto",
            flexGrow: 1,
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 2,
            mt: 2,
          }}
        >
         



          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
{t("salaryManagement.amount")}          </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
                    {data?.amount} {data?.currency}
            </CustomText>{" "}
          </Box>

          {data?.payment_method && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("salaryManagement.paymentMethod") || "Payment Method"}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                  textTransform: "capitalize",
                }}
              >
                {data.payment_method === "bank"
                  ? "Bank Transfer"
                  : data.payment_method === "transfer"
                  ? "Wire Transfer"
                  : data.payment_method === "cash"
                  ? "Cash"
                  : data.payment_method === "other"
                  ? "Other"
                  : data.payment_method}
              </CustomText>
            </Box>
          )}

          {data?.type === "expense_reimbursement" && data?.source_expense_id && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("salaryManagement.relatedExpense") || "Related Expense"}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
                #{data.source_expense_id}
                {data?.expense?.description && ` - ${data.expense.description}`}
              </CustomText>
            </Box>
          )}


        </Box>

        {/* Recipe Box (Optional) */}

        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
          sx={{ mt: 2 }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                fontWeight: 600,
                color: "#000000",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.receipt")}
            </CustomText>
            <img src={down} width={40} height={30} />
          </Box>

          <Box>
            <img src={receipt} style={{ width: 30, height: 30 }} />
          </Box>
        </Box>

 <Box
  sx={{
    p: 2,
    overflowY: "auto",
    flexGrow: 1,
    border: "1px solid #E4E6EF",
    borderRadius: 2,
    mt: 2,
    display: "flex",
    justifyContent: "center", // center horizontally
    alignItems: "center"       // center vertically
  }}
>
  <img
    crossOrigin="anonymous"
    src={data?.attachment_url}
    style={{
      maxWidth: "100%",   // don’t overflow box width
      maxHeight: "250px", // control height
      objectFit: "contain",
      borderRadius: "8px"
    }}
    alt="Proof"
  />
</Box>

     
      </Box>
     
    </Drawer>
  );
};

export default DetailsDrawer;